<div class="card modern-card">
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Items Available For Disposition</h1>
      </div>

      <div class="header-actions">
        <button
          type="button"
          class="close-btn"
          (click)="openHome()"
          title="Close"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body px-4 py-2">
    <div class="row h-100">
      <div class="col-9 h-100 pb-3" style="min-height: 70vh">
        <ag-grid-angular
          id="dispo_list"
          class="modern-grid"
          style="width: 100%; height: 100%"
          
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [gridOptions]="gridOptions"
          [rowData]="rowData"
          [overlayLoadingTemplate]="overlayLoadingTemplate"
          [animateRows]="true"
          [components]="components"
          (cellClicked)="cellSingleClicked($event)"
          (gridReady)="onGridReady($event)"
          [enableBrowserTooltips]="true"
        ></ag-grid-angular>
      </div>
      <div class="col-3 h-100 pb-3" style="min-height: 70vh">
        <div class="rounded-3 p-3 h-100 d-flex flex-column" style="background: rgba(0, 0, 0, 0.2); border: 1px solid rgba(255, 255, 255, 0.05);">
          <span class="text-center fw-medium fs-5 mb-2" style="color: white">Selected Items</span>
          <hr class="border-secondary mt-0 mb-3" />
          <div class="flex-grow-1 overflow-auto">
            @for (
              item of sharedService.selected_firearms_for_disposition;
              track item;
              let i = $index
            ) {
              <div class="alert alert-secondary selected-item p-2 mb-2">
                <span style="font-size: 14px">
                  {{ i + 1 }}) {{ item.firearm }} - Serial#
                  {{ item.serial_number }}
                </span>
              </div>
            }
            @if (sharedService.selected_firearms_for_disposition.length === 0) {
              <div class="text-center text-light fst-italic mt-4">
                No items selected.
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-footer border-top border-secondary bg-transparent px-4 py-3">
    <div class="row align-items-center">
      <div class="col-9 d-flex gap-2 flex-wrap">
        <!-- Refresh -->
        <button
          type="button"
          class="btn modern-btn red-btn flex-fill"
          (click)="refreshTableDataClick()"
        >
          Refresh
        </button>
        <!-- Lost or Stolen -->
        <button
          type="button"
          class="btn modern-btn grey-btn  flex-fill"
          (click)="lostStolenItemClick()"
          [disabled]="
            sharedService.selected_firearms_for_disposition.length === 0
          "
        >
          Report Lost/Stolen Items
        </button>
        <!-- Destroy -->
        <button
          type="button"
          class="btn modern-btn grey-btn  flex-fill"
          (click)="destroyItemClick()"
          [disabled]="
            sharedService.selected_firearms_for_disposition.length === 0
          "
        >
          Report Destroyed Items
        </button>
        <!-- Reserve Items -->
        <button
          type="button"
          class="btn modern-btn red-btn  flex-fill"
          (click)="reserveItemsClick()"
          [disabled]="
            sharedService.selected_firearms_for_disposition.length === 0
          "
        >
          Reserve Item(s)
        </button>
        <!-- Dispo to ffl -->
        <button
          type="button"
          class="btn modern-btn blue-btn  flex-fill"
          (click)="dispoToFflClick()"
          [disabled]="
            sharedService.selected_firearms_for_disposition.length === 0
          "
        >
          Disposition To FFL
        </button>
        <!-- Dispo to Individual -->
        <button
          type="button"
          class="btn modern-btn blue-btn  flex-fill"
          (click)="dispoToIndividualClick()"
          [disabled]="
            sharedService.selected_firearms_for_disposition.length === 0
          "
        >
          Disposition To Individual
        </button>
      </div>
      <div class="col-3 d-flex justify-content-center">
        <!-- Clear Selection -->
        <button
          class="btn modern-btn red-btn  w-100"
          (click)="clearSelectionsClick()"
          [disabled]="
            sharedService.selected_firearms_for_disposition.length === 0
          "
        >
          Clear Selections
        </button>
      </div>
    </div>
  </div>
</div>
